<div class="status-legend-card">
  <div class="status-legend-header">
    <mat-icon>assignment</mat-icon>
    <h3>Stati del Libretto</h3>
  </div>
  <div class="status-legend-content">
    <table class="status-table">
      <thead>
        <tr>
          <th class="status-col">Stato</th>
          <th class="desc-col">Descrizione</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let status of statuses; trackBy: trackByStatus">
          <td class="status-cell">
            <div class="status-badge"
              [ngClass]="status.className">
              <span>{{ status.label }}</span>
            </div>
          </td>
          <td class="desc-cell"
            [innerHTML]="sanitizeHtml(status.description)"></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>